import React from "react";
import Image from "next/image";

import { useRouter } from "next/router";
import Link from "next/link";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { colors, font } from "utils/styles";
import Img from "public/img/wheres-my-page.jpg";
import opsGenie from "@utils/OpsGenie";

export default function Error500() {
	// const router = useRouter();

	return (
		<Container className="mb-5">
			<Row>
				<Col className="d-flex flex-column align-items-center">
					<h2 className="title">
						Sorry, the page you are looking for cannot be found.
						{/* Sorry, the page you are looking for "<i>{path}</i>" cannot be found */}
					</h2>
					<Link href="/">
						<h3>AAPL Home Page</h3>
					</Link>
					<Image placeholder="blur" style={{ width: "100%", height: "auto" }} src={Img} alt="" />
				</Col>
			</Row>

			<style jsx="true">{`
				.title {
					font-family: ${font.Athelas};
					color: ${colors.darkBlue};
				}
				a {
					color: ${colors.green} !important;
				}
			`}</style>
		</Container>
	);
}

export async function getStaticProps() {
	//This is only ran at build time, not very useful.
	// await opsGenie.alert({ message: "500 error occurred", description: "Custom 500 page rendered" });
	return { props: {} };
}
